/**
 * togglePassword creates the on click listener for '.js-toggle-password'.
 *
 * The on click listener toggles the input type 'text' and 'password' on the given element.
 * The '.js-toggle-password' element requires:
 * - data-input-element: String        (The password input element to toggle, ie '#element' or '.element')
 */

function togglePassword() {
	$(document).on('click', '.js-toggle-password', function() {
		const $this = $(this);
		const targetElement = $this.data('input-element');
		const $target = $(targetElement);

		if ($target.attr('type') == 'password') {
			$target.attr('type', 'text');
		} else {
			$target.attr('type', 'password');
		}
	});
}
togglePassword();
